/** French formatting helpers (ported from web/src/lib/format.ts). Amounts travel as integer cents. */
const eur = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
const eurRound = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
const nbsp = (s: string) => s.replace(/\u202f/g, "\u00a0");

export function formatCents(cents: number, opts: { round?: boolean } = {}): string {
  return nbsp((opts.round ? eurRound : eur).format(cents / 100));
}

const dateShort = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "short", year: "numeric" });
const dateLong = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long", year: "numeric" });
const time = new Intl.DateTimeFormat("fr-FR", { hour: "2-digit", minute: "2-digit" });

export const formatDate = (iso: string) => dateShort.format(new Date(iso));
export const formatDateLong = (iso: string) => dateLong.format(new Date(iso));
export const formatTime = (iso: string) => time.format(new Date(iso));

/** Two-letter initials for avatars: "Atelier Roux" → "AR". */
export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join("");
}

/** Days until a date (negative when past). */
export function daysUntil(iso: string, now = new Date()): number {
  const ms = new Date(iso).setHours(0, 0, 0, 0) - new Date(now).setHours(0, 0, 0, 0);
  return Math.round(ms / 86_400_000);
}
